import moment from 'moment'

export const calculateAge = (dateOfBirth: string, dateToCompare: string) => {
  const today = moment(dateToCompare)
  const birthDate = moment(dateOfBirth)
  let age = today.diff(birthDate, 'years')

  return age
}
